import {
  validateAccountNumber,
  validatePhone,
  validateAccountExists,
} from '../../../../util/form-validation';
import {
  AccountLookUpType,
  OutageLookUpType,
} from '../../../../__generated__/pge-types';
import { convertValidationRules } from '../../../../hooks/useFormState';
import { BaseValidationContext } from '../../../../hooks/useFormState.types';
import { ApolloClient } from 'apollo-client';

export type Model = {
  lookUpType: OutageLookUpType;
  lookUpPhoneNumber: string;
  lookUpAccountNumber: string;
};

type AdditionalContext = {
  apolloClient: ApolloClient<any>;
};

async function validateLookUpParams(
  value: string,
  context: BaseValidationContext<Model> & AdditionalContext,
) {
  const error =
    context.values.lookUpType === OutageLookUpType.Phone
      ? validatePhone(value)
      : validateAccountNumber(value);

  if (error !== null) {
    return error;
  }

  if (context.phase === 'submit') {
    const asyncError = await validateAccountExists(
      value,
      context.values.lookUpType === OutageLookUpType.Phone
        ? AccountLookUpType.Phone
        : AccountLookUpType.Account,
      context.apolloClient,
    );

    return asyncError;
  }
}

export default convertValidationRules<Model, AdditionalContext>(context => {
  const { lookUpType } = context.values;
  return {
    lookUpAccountNumber:
      lookUpType === OutageLookUpType.Account ? validateLookUpParams : null,
    lookUpPhoneNumber:
      lookUpType === OutageLookUpType.Phone ? validateLookUpParams : null,
  };
});
